import React, { useEffect, useState } from "react";
import API from '../Services/AddPackage'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import moment from "moment";
import LocationList from "./Location";
import TaxRateListList from "./TaxRate";
import CenterModal from "./CenterModal";


const ActivityList = () => {
    const [activityList, setActivityList] = useState([])
    const [error, setError] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState(null)
    const [status, setStatus] = useState("");
    const limit = 10;
    const [name, setName] = useState("");
    const [amount, setAmount] = useState("");
    const [logoPreview, setLogoPreview] = useState(null);
    const [image, setImage] = useState("");
    const [locationId, setLocationId] = useState("");

    const [type, setType] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [comboTax, setComboTax] = useState("")
    const [comboTaxName, setComboTaxName] = useState("")
    const [locationName, setLocationName] = useState("")
    const [selectedCenter, setSelectedCenter] = useState([]);

    const [search, setSearch] = useState("")

    useEffect(() => {
        getActivityList()
    }, [currentPage]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;

            case "amount":
                setAmount(value);
                break;

            case "type":
                setType(value);
                break;

            case "locationId":
                setLocationId(value);
                break;

            case "image":
                setImage(value);
                break;

            case "search":
                setSearch(value);
                break;

            default:
                break;
        }
    };


    const validateFields = () => {
        const newErrors = {};
        if (!locationId) newErrors.locationId = "Location is required.";
        if (!String(type).trim()) newErrors.type = "Type is required.";
        if (!String(name).trim()) newErrors.name = "Name is required.";
        if (!String(amount).trim()) newErrors.amount = "Amount is required.";
        //if (!image) newErrors.image = "Image is required.";

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        // console.log("file.....", file)
        if (file) {
            const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 5 * 1024 * 1024;
            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPG PNG and GIF formats are allowed.")
                event.target.value = '';
                return;
            }
            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.")
                event.target.value = '';
                return;
            }
            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const getActivityList = async () => {
        try {
            const response = await API.get_Addon({
                id: null,
                page: currentPage,
                limit: 10,
                type: null,
                search: null || search
            });
            setActivityList(response?.data?.result);
            setTotalRecords(response?.data?.totalCount)
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch membership data.",
            }));
            handleError(error);
        }
    };


    const handleError = (error) => {
        // console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const totalPages = Math.ceil(totalRecords / limit);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    }

    const handleGetData = async (id) => {
        try {
            const response = await API.get_Addon({ id: id });
            // console.log('ffffff', response?.data?.result);
            const fetchedData = response?.data?.result?.[0];
            if (fetchedData) {
                setId(fetchedData.id);
                setName(fetchedData.name);
                setLocationId(fetchedData?.location_id)
                setType(fetchedData.type);
                setAmount(fetchedData?.amount);
                setStatus(fetchedData?.is_active);
                setCreatedAt(fetchedData?.createdAt);
                setLogoPreview(fetchedData?.image)
                setComboTax(fetchedData?.tax_rate_id);
                setComboTaxName(fetchedData?.tax_rate);
                setLocationName(fetchedData?.Location?.name)

            } else {
                toast.error("Failed to fetch  details.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updateActivityList = async () => {
        //    if (!validateFields()) return;
        const formData = new FormData();
        formData.append("location_id", parseInt(locationId));
        formData.append("name", name);
        formData.append("amount", amount);
        formData.append("type", type);
        formData.append("tax_rate_id", comboTax);
        if (image instanceof File) {
            formData.append("image", image);
        }
        try {
            const response = await API.updateActivity(id, formData);
            // console.log("response data......", response?.data?.message)
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Add-on product updated successfully!");
                getActivityList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update activity.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };


    const handleUpdate = async () => {
        //console.log("...........")
        if (!validateFields()) return;
        await updateActivityList();
    };
    const handleGetLogo = (logo) => {
        // console.log("logo data...", logo)
        setImage(logo)
    }

    const changeStatus = async (id, currentStatus) => {
        //console.log("stauttsss..", id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeActivityStatus(id, updatedStatus);
            if (response.status === 200) {
                setActivityList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Add On Activity ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getActivityList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };
    const handleSearch = () => {
        getActivityList();
    };

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">

                <div className="card">

                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added AddOn</h4>
                    </div>

                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <input type="text" className="form-control" placeholder="Search"
                                    value={search}
                                    onChange={(e) => handleFieldChange(e, "search")}
                                />
                            </div>
                            <div className="col-md-3">
                                <label></label>
                                <button
                                    type="button"
                                    className="btn btn-success mt-3"
                                    onClick={handleSearch}
                                >Search</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center Name</th>
                                        <th>Amount</th>
                                        <th>Tax Rate</th>
                                        <th>Type</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                        <th>Image</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {activityList.length > 0 ? (
                                        activityList.map((item, index) => (

                                            <tr key={item?.id || index} data-active={item?.is_active ? "true" : "false"}>
                                                <td>{(currentPage - 1) * limit + index + 1}</td>

                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalActivityList">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModal"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item?.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item?.id, item?.is_active)}
                                                                        >
                                                                            {item?.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>{item?.name}</td>
                                                <td>{item?.Location?.name}</td>
                                                <td>{item?.amount}</td>
                                                <td>{item?.tax_rate}</td>
                                                <td>{item?.type}</td>


                                                <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                                <td>{moment(item?.createdAt).format("DD-MM-YYYY")}</td>
                                                <td>

                                                    {/* {item.logo && item.logo.trim() !== "" ? (
                                                    <button
                                                        onClick={() => handleGetLogo(item.logo)}
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#myModallogo"
                                                    >
                                                        View
                                                    </button>
                                                ) : "N/A"} */}
                                                    {item.image && item.image.trim() !== "" ? (
                                                        <button onClick={() => handleGetLogo(item.image)}
                                                            className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo">
                                                            View
                                                        </button>
                                                    ) : "N/A"}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Record found.</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>

            <section>
                <div className="modal" id="myModalActivityList">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Add On</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>

                                            <th>Name</th>
                                            <th>Center Name</th>
                                            <th>Amount</th>
                                            <th>Type</th>

                                        </tr>
                                        <tr>
                                            <td>{name}</td>
                                            <td>{locationName}</td>
                                            <td>{amount}</td>
                                            <td>{type}</td>

                                        </tr>

                                        <tr>
                                            <th>Tax Rate Name</th>
                                            <td>Icon</td>
                                            <th>Status</th>
                                            <th colSpan={2}>createdAt</th>
                                        </tr>
                                        <tr>
                                            <td>{comboTaxName}</td>
                                            {/* <td><img src={logoPreview} alt="Logo" style={{ width: '20%', height: '100px' }} /></td> */}
                                            <td>
                                                {logoPreview ? (
                                                    <img
                                                        src={logoPreview}
                                                        alt="Image"
                                                        width="50"
                                                        height="50"

                                                    />
                                                ) : (
                                                    <span>No Image Available</span>
                                                )}
                                                {/* <img src={logoPreview || 'No Image Available'} alt="Image" /> */}
                                            </td>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            <td colSpan={2}>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="modal-footer">

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update AddOn</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <LocationList
                                                selectedLocation={locationId}
                                                label="Center"
                                                isRequired={false}
                                                disabled={true}
                                                setSelectedLocation={(location) => {
                                                    setLocationId(location);
                                                    if (location.trim()) {
                                                        setError((prevErrors) => {
                                                            const updatedErrors = { ...prevErrors };
                                                            delete updatedErrors.locationId;
                                                            return updatedErrors;
                                                        });
                                                    }
                                                }}
                                            />
                                            {error?.locationId && <span className="text-danger">{error.locationId}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>
                                                Type <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={type}
                                                onChange={(e) => handleFieldChange(e, "type")}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="service">Service</option>
                                                <option value="product">Product</option>
                                            </select>
                                            {error?.type && <span className="text-danger">{error.type}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>
                                                Name <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}

                                            />
                                            {error?.name && <span className="text-danger">{error.name}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                            taxRates={comboTax}
                                        />

                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>
                                                Price <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Amount"
                                                value={amount}
                                                onChange={(e) => handleFieldChange(e, "amount")}
                                            />
                                            {error?.amount && <span className="text-danger">{error.amount}</span>}
                                        </div>
                                    </div>
                                    {/* <div className="col-md-4">
                                        <label>
                                            Upload Image <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/png, image/gif, image/jpeg"
                                            id="txtimage"
                                            onChange={handleLogoChange}
                                        />
                                        {error?.image && <span className="text-danger">{error.image}</span>}
                                    </div> */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Website">Upload Icon</label>
                                            <input
                                                accept="image/png, image/gif, image/jpeg"
                                                type="file"
                                                className="form-control"
                                                id="txtimage"
                                                onChange={handleLogoChange}
                                            />

                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        {logoPreview && (
                                            <div className="mt-2">
                                                <img
                                                    src={logoPreview || 'No Image Available'}
                                                    alt="Logo Preview"
                                                    style={{ width: 100, height: 100, objectFit: "cover" }}
                                                />
                                            </div>
                                        )}
                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" type="button" onClick={handleUpdate} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModallogo">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Image</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row my-3" style={{ justifyContent: "center" }}>
                                    <img src={image || 'No Image Available'} alt="Logo" style={{ "width": "200px", "height": "150px" }} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    );
};

export default ActivityList;